'use client';

import { ReactElement } from 'react';
import { AcceptsDataTestid } from '@bts-web/utils-test/types';
import { css } from '@bts-web/utils-style-engine';
import { CheckboxToggle } from '../CheckboxToggle/CheckboxToggle';

interface AcceptTermToggleProps extends AcceptsDataTestid {
  label: string | ReactElement;
  detailedDescription?: string;
  termsAgreed: boolean;
  onToggleCallback: () => void;
}

const AcceptTermToggle = ({
  label,
  detailedDescription,
  termsAgreed,
  onToggleCallback,
  'data-testid': testIdSuffix,
}: AcceptTermToggleProps) => (
  <>
    <div
      className={css({
        display: 'flex',
        gap: 'small',
        justifyContent: 'space-between',
        width: '100%',
      })}
      data-testid={
        testIdSuffix
          ? `accept-term-toggle-${testIdSuffix}`
          : 'accept-term-toggle'
      }
    >
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          gap: 'extra_small_2',
          textAlign: 'left',
        })}
      >
        <p
          className={css({
            color: 'neutrals.text_primary',
            fontSize: 'body.medium',
            fontWeight: 500,
            letterSpacing: 'body.medium',
            lineHeight: 'body.medium',
            flex: 1,
          })}
        >
          {label}
        </p>

        {detailedDescription ? (
          <p
            className={css({
              color: 'neutrals.text_secondary',
              marginInlineStart: 'auto',
              fontSize: 'body.medium',
              fontWeight: 'body.medium',
              letterSpacing: 'body.medium',
              lineHeight: 'body.medium',
            })}
          >
            {detailedDescription}
          </p>
        ) : null}
      </div>

      <CheckboxToggle
        aria-label={typeof label === 'string' ? label : undefined}
        checked={termsAgreed}
        onChange={onToggleCallback}
      />
    </div>
  </>
);

export { AcceptTermToggle };
